export var clientOwnersMapper = function (data) {
    if (data) {
        var ownersEntity = {
            salesAgent: data.sales_Agent,
            clientOwner: data.client_Owner,
            eqAdvisor: data.eq_Advisor,
            wealthRM: typeof data.wealth_RM === "object" ? data.wealth_RM : null,
            esopRM: typeof data.esop_RM === "object" ? data.esop_RM : null,
            turtle: typeof data.turtle === "object" ? data.turtle : null,
            cdd: typeof data.cdd === "object" ? data.cdd : null,
            elliancePartner: data.elliancePartner,
            elliancePartnerAcquired: data.elliancePartner_Acquired,
            elliancePartnerCode: data.elliancePartner_Code,
            cxo: data.cxo,
            frm: data.frm,
        };
        console.log("ownersEntity", ownersEntity);
        return ownersEntity;
    }
    else {
        return {};
    }
};
